import { processApiPayload } from "@rmp/core/utils/api";

export function transformRequest(data: any) {
	// FormData отдаётся axios как есть: сериализацию multipart делает браузер
	if(data instanceof FormData) {
		return data;
	}

	if(data) {
		processApiPayload(data);
	}
	
	return JSON.stringify(data);
}
